import AuthPage from '../../AuthPage';

function OgrenciGirisPage() {
  return (
    <AuthPage 
      role="student"
      title="Student Login"
      icon="🎓"
      redirectPath="/student/"
    />
  );
}

export default OgrenciGirisPage;